import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

import { getOrderDetailsPropType } from '../../../../utils/orderTools'

const StyledAddress = styled.address`
  font-style: inherit;
`

const ShippingAddress = ({ className, order }) =>
  order.shippingAddress ? (
    <div className={classnames(className, 'paragraph-text')}>
      <div className="heading">Shipped to:</div>
      <StyledAddress>
        <strong className="shipping-address-detail">{order.shippingAddress.addressee}</strong>
        <div className="shipping-address-detail">
          {order.shippingAddress.street.map((streetData) => (
            <span key={streetData}> {streetData}</span>
          ))}
        </div>
        <div className="shipping-address-detail">
          {order.shippingAddress.city}, {order.shippingAddress.state}{' '}
          {order.shippingAddress.countryCode} {order.shippingAddress.zip}
        </div>
      </StyledAddress>
      <div className="shipping-address-detail">{order.shippingAddress.phone}</div>
    </div>
  ) : null

ShippingAddress.defaultProps = {
  className: '',
}

ShippingAddress.propTypes = {
  className: PropTypes.string,
  order: getOrderDetailsPropType().isRequired,
}

const StyledShippingAddress = styled(ShippingAddress)({
  marginBottom: '30px',
  '.heading': {
    marginBottom: '24px',
  },
  '.shipping-address-detail': {
    display: 'block', // Ensure the strong tag around the name applies the margin too
    marginBottom: '4px',
  },
  '@media(min-width: 600px)': {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    '.paragraph-text': {
      flex: '1',
    },
  },
})

export default StyledShippingAddress
